import { Paperclip, Send, X } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';

const MessageInput = () => {
  const {
    travellerMessageText,
    setTravellerMessageText,
    travellerChatAttachment,
    setTravellerChatAttachment,
    travellerChatAttachmentPreview,
    setTravellerChatAttachmentPreview,
    isSendingTravellerMsg,
    handleSendTravellerMessage,
    handleTravellerAttachmentChange,
    travellerFileInputRef
  } = useSupport();

  return (
    <div className="p-3 md:p-4 border-t border-gray-100 bg-white">
      {travellerChatAttachmentPreview && (
        <div className="mb-3 relative inline-block">
          <img
            src={travellerChatAttachmentPreview}
            className="h-16 w-16 object-cover rounded-xl border border-gray-200"
            alt="Preview"
          />
          <button
            onClick={() => {
              setTravellerChatAttachment(null);
              setTravellerChatAttachmentPreview(null);
            }}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 shadow-md hover:bg-red-600 transition-colors cursor-pointer"
          >
            <X size={10} />
          </button>
        </div>
      )}

      <div className="flex items-center gap-2 md:gap-3">
        <button
          disabled={isSendingTravellerMsg}
          onClick={() => travellerFileInputRef.current?.click()}
          className="p-2 text-gray-400 hover:text-[#067978] transition-colors cursor-pointer disabled:opacity-50"
        >
          <Paperclip size={18} />
        </button>
        <input
          type="file"
          ref={travellerFileInputRef}
          className="hidden"
          accept="image/*"
          onChange={handleTravellerAttachmentChange}
          disabled={isSendingTravellerMsg}
        />

        <input
          type="text"
          placeholder="Type your message..."
          value={travellerMessageText}
          onChange={(e) => setTravellerMessageText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSendTravellerMessage()}
          disabled={isSendingTravellerMsg}
          className="flex-1 px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-xs sm:text-sm text-gray-800 placeholder-gray-400 outline-none focus:border-[#067978] focus:bg-white font-normal transition-all"
        />

        <button
          disabled={
            isSendingTravellerMsg ||
            (!travellerMessageText.trim() && !travellerChatAttachment)
          }
          onClick={handleSendTravellerMessage}
          className={`p-2.5 rounded-xl transition-all cursor-pointer ${
            isSendingTravellerMsg ||
            (!travellerMessageText.trim() && !travellerChatAttachment)
              ? 'text-gray-300 bg-gray-100 cursor-not-allowed'
              : 'bg-[#067978] text-white shadow-md hover:bg-teal-700 active:scale-95'
          }`}
        >
          {isSendingTravellerMsg ? (
            <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
          ) : (
            <Send size={16} />
          )}
        </button>
      </div>
    </div>
  );
};

export default MessageInput;
